import React from 'react'
import PropTypes from 'prop-types'

export const Points = ({ points }) => {
  return <>{points == 1 ? 'point' : 'points'}</>
}
Points.propTypes = {
  points: PropTypes.number
}
